var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookopenselc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book-open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 3.8147H8.5C9.56087 3.8147 10.5783 4.23612 11.3284 4.98627C12.0786 5.73642 12.5 6.75383 12.5 7.8147V21.8147C12.5 21.019 12.1839 20.256 11.6213 19.6934C11.0587 19.1308 10.2956 18.8147 9.5 18.8147H2.5V3.8147Z",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 3.8147H16.5C15.4391 3.8147 14.4217 4.23612 13.6716 4.98627C12.9214 5.73642 12.5 6.75383 12.5 7.8147V21.8147C12.5 21.019 12.8161 20.256 13.3787 19.6934C13.9413 19.1308 14.7044 18.8147 15.5 18.8147H22.5V3.8147Z",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookopenselc);
export default __webpack_public_path__ + "static/media/bookopenselc.47bfc83a0cd3a24d31276e6c8f0504f2.svg";
export { ForwardRef as ReactComponent };